import React, { createContext, useEffect, useState } from 'react';
import app from '../../Firebase/firebase.config';
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile } from "firebase/auth";
export const AuthContext = createContext();
const auth = getAuth(app)
const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    
    // Register/signUP
    const signUp = (email,password)=>{
        setLoading(true)
        return createUserWithEmailAndPassword(auth, email, password)
    }
    // profile
    const createProfile = (profile)=>{
        setLoading(true)
        return updateProfile(auth.currentUser,profile)
    }
    // login
    const login = (email, password)=>{
        setLoading(true)
        return signInWithEmailAndPassword(auth, email,password)
    }
    // logout
    const logout = ()=>{
        setLoading(true)
        return signOut(auth)
    }
    // GoogleLogin
    const googleSign = (provider)=>{
        setLoading(true)
        return signInWithPopup(auth,provider)
    }
    // Get the current user
    useEffect(()=>{
        const unsubcribe = onAuthStateChanged(auth,(currentUser)=>{
            setUser(currentUser);
            setLoading(false)
        })
        return ()=>{
            unsubcribe()
        }
    },[])
    const authInfo = {user, signUp, createProfile,login, googleSign, loading, logout}
    return (
        <AuthContext.Provider value={authInfo}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;